import script from "./HotelsSearchCriteriaComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HotelsSearchCriteriaComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HotelsSearchCriteriaComponent.vue?vue&type=style&index=0&id=8f4d57d2&lang=css"

const __exports__ = script;

export default __exports__